// Tab + filter selection logic — pure functions over the board's event
// groups so tab switching and the sport/league filter row stay testable
// without rendering.

import type { EventGroup, EventSnapshot } from '../feed';

export const matchesFilters = (
  event: Pick<EventSnapshot, 'sport' | 'league'>,
  sport: string,
  league: string,
): boolean =>
  (!sport || event.sport.toLowerCase() === sport.toLowerCase()) &&
  (!league || event.league === league);

export function filterGroups(
  groups: EventGroup[],
  sport: string,
  league: string,
): EventGroup[] {
  return groups.filter((g) => matchesFilters(g.event, sport, league));
}

/** Distinct sports across groups, case-insensitive (imports mix
 * "Soccer"/"soccer"), displayed title-cased, alphabetically sorted. */
export function sportOptions(...groupSets: EventGroup[][]): string[] {
  const seen = new Set<string>();
  for (const groups of groupSets) {
    for (const g of groups) {
      const key = g.event.sport.toLowerCase();
      if (key) seen.add(key);
    }
  }
  return [...seen].sort();
}

/** Distinct leagues within the selected sport (all leagues when no sport
 * is selected), sorted, first-appearance deduped. */
export function leagueOptions(groups: EventGroup[], sport: string): string[] {
  const seen = new Set<string>();
  for (const g of groups) {
    if (sport && g.event.sport.toLowerCase() !== sport.toLowerCase()) continue;
    if (g.event.league) seen.add(g.event.league);
  }
  return [...seen].sort();
}
